import { Component, OnInit } from '@angular/core';
import { PermissionService } from 'src/app/modules/wino-shared/services/permission.service';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.css']
})
export class PageNotFoundComponent implements OnInit {

  constructor(private permissionService: PermissionService) { }

  ngOnInit(): void {
    this.permissionService.updateTitleBarData("Pagina non trovata...", false);
  }
}